<template>
  <div
    class="item-card card-dark"
  >
    <LazyPagesItemComponentsChildrenThumb
      :font-size="10"
      :image-height="150"
      :image-width="200"
      :item="item"
      :size="8"
      :src="getImageFromWaxpeer(item.img_link_name)"
    />

    <span
      v-if="
        getItemNameOnly(item.item_name)
          !== getWeaponOnly(item.item_name)
      "
      class="item-card__category"
    >
      {{ getWeaponOnly(item.item_name) }}
    </span>
    <nuxt-link
      :aria-label="`Link to skin${item.item_name}`"
      :to="getItemLink({ slug: item.link_name })"
      class="item-card__name ell"
    >
      {{ getItemNameOnly(item.item_name) }}
    </nuxt-link>
  </div>
</template>

<script lang="ts" setup>
import { getWeaponOnly } from '~/utils/name-utils';

defineProps<{
  item: any
}>();
</script>

<style lang="scss" scoped>
.item-card {
  padding: 12px;

  :deep(.thumb) {
    padding: 0;
  }
}

.item-card {
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--surfaces-low-container);
  position: relative;

  &__category {
    font-size: 14px;
    color: var(--surfaces-on-surface-variable);
    width: 100%;
  }

  &__name {
    font-weight: 700;
    font-size: 14px;
    width: 100%;
    color: var(--surfaces-on-surface);

    &:after {
      content: '';
      display: block;
      position: absolute;
      inset: 0;
    }
  }

  &:deep(.thumb) {
    padding: 0;
    min-height: unset !important;
    width: 124px;
    height: unset;

    img {
      transition: 0.5s scale;
    }

    .thumb_bg:before {
      content: none;
    }

    @media screen and (max-width: 768px) {
      width: 100%;
      min-width: 100%;
      height: unset;
    }
  }

  &:hover,
  &:focus {
    :deep(.thumb) img {
      scale: 1.1;
    }
  }
}
</style>
